"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  en: {
    attendee: 'Attendee',
    status: {
      registered: 'Registered',
      pending: 'Pending',
      unassigned: 'Unassigned attendee'
    },
    actions: {
      seeDetails: 'See details'
    },
    dates: {
      startDate: 'Start date',
      time: 'Time'
    }
  },
  es: {
    attendee: 'Asistente',
    status: {
      registered: 'Registrado/a',
      pending: 'Pendiente',
      unassigned: 'Asistente no asignado'
    },
    actions: {
      seeDetails: 'Ver detalles'
    },
    dates: {
      startDate: 'Fecha de inicio',
      time: 'Hora'
    }
  },
  fr: {
    attendee: 'Participant',
    status: {
      registered: 'Enregistré/e',
      pending: 'En attente',
      unassigned: 'Participant non assigné'
    },
    actions: {
      seeDetails: 'Voir les détails'
    },
    dates: {
      startDate: 'Date de début',
      time: 'Heure'
    }
  },
  de: {
    attendee: 'Teilnehmer',
    status: {
      registered: 'Registriert',
      pending: 'Ausstehend',
      unassigned: 'Nicht zugewiesener Teilnehmer'
    },
    actions: {
      seeDetails: 'Details anzeigen'
    },
    dates: {
      startDate: 'Startdatum',
      time: 'Uhrzeit'
    }
  }
};
exports["default"] = _default;